import React from 'react';

import './NotFound.scss';

class NotFound extends React.Component {
  render() {
    return (
      <div className="not-found-wrapper">
        <div className="not-found">
          <div className="not-found__title">Oops...</div>
          <div className="not-found__message">
            I guess we haven&apos;t started on that yet.
          </div>
        </div>
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/pages/NotFound.jsx